// Dieser Spinner wurde entfernt und wird durch den nativen Browser-Ladeindikator ersetzt
// Die Datei bleibt für Kompatibilitätszwecke, enthält aber keine aktive Funktionalität mehr

import React from 'react'

export const LoadingSpinner = () => {
  // Leere Komponente, die keinen sichtbaren Inhalt rendert
  return null
}

export default LoadingSpinner